/* eslint-disable max-len */
import {
  ESGCertification,
  ESGCertVerifier,
  ESGCertType
} from '../../types/deal.types';
import { ESGValues } from '../../grid/utils/value-getters/esg';

export enum BadgeType {
  solid = 'solid',
  gray = 'gray',
  outline = 'outline'
}

export function esgGetBadgeClass(data: ESGCertification) {
  if (data.esgCertType) {
    return `esg-icon ${data.esgCertType.toLowerCase()}-${esgGetBadgeType(
      data
    )}`;
  }
  return '';
}

export function esgGetBadgeType({
  esgCertVerifier,
  esgCertType,
  esgPreapprovedInd
}: ESGCertification) {
  if (esgCertType === ESGCertType.Various) {
    return '';
  }

  if (esgPreapprovedInd) {
    return BadgeType.gray;
  }

  if (!!esgCertVerifier && esgCertVerifier !== 'Self') {
    return BadgeType.solid;
  } else {
    return BadgeType.outline;
  }
}

export function esgPreApprovalMsg(
  { esgCertVerifier, esgCertType, esgPreapprovedInd }: ESGValues,
  printVerifier?: boolean
): string {
  if (esgPreapprovedInd) {
    if (esgCertVerifier === ESGCertVerifier.Kestrel) {
      return `${esgCertVerifier} Verifiers, a ${esgCertType} Bonds Initiative Approved Verifier, has pre-qualified this transaction as conforming with the ICMA Green, Social or Sustainability Bond Principles, and an external review is available. Please contact a participating bidding dealer for additional detail or to express your interest in adding this designation.`;
    } else {
      return `${esgCertVerifier} has pre-qualified this transaction as conforming with the ICMA Green, Social or Sustainability Bond Principles, and an external review is available. Please contact a participating bidding dealer for additional detail or to express your interest in adding this designation.`;
    }
  }
  if (printVerifier) {
    return esgCertVerifier;
  }
  return '';
}
